"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchNoticeList = exports.getBrowserLang = void 0;

var config_1 = require("../constants/config");

var load_script_1 = __importDefault(require("load-script"));

var getBrowserLang = function getBrowserLang() {
  var lang = "vi";
  var aLang = {
    "vi": "vi_VN",
    "vi-VN": "vi_VN"
  };

  if (!window.navigator.language) {
    lang = "vi";
  }

  lang = window.navigator.language;
  lang = lang.toLocaleLowerCase();

  if (lang === "zh-tw" || lang === "zh-cn") {
    return aLang[lang];
  }

  lang = lang.substring(0, 2);
  return aLang[lang];
};

exports.getBrowserLang = getBrowserLang;

function fetchNoticeList() {
  var noticeList = Array();
  var lang = exports.getBrowserLang();
  var url = "".concat(config_1.STATIC_FILE_URL, "/data/onlive_notice_portlet_vi_VN.js");
  load_script_1.default("".concat(url), {
    charset: "utf-8"
  }, function () {
    if (typeof window.onlive_notice_item_sort != "undefined" && window.onlive_notice_item_sort.length > 0) {
      window.onlive_notice_item_sort.forEach(function (element) {
        noticeList.push({
          'i_link_url': window.onlive_notice_item_link_url[element],
          'i_title': window.onlive_notice_item_title[element],
          'i_reg_date': window.onlive_notice_item_reg_date[element]
        });
      });
    }
  });
  return noticeList;
}

exports.fetchNoticeList = fetchNoticeList;